import { render, staticRenderFns } from "./OtherUserMessageHistoryDetail.vue?vue&type=template&id=4e531b7d&lang=pug"
import script from "./OtherUserMessageHistoryDetail.vue?vue&type=script&lang=ts"
export * from "./OtherUserMessageHistoryDetail.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserMessageHistoryDetail.vue?vue&type=style&index=0&id=4e531b7d&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports